module.exports = __webpack_public_path__ + "img/no-reports-svg.6d31011c.svg";